import React, { useContext, useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import "../../../assets/css/user/featuredDeals/FeaturedDeals.css";
import { useNavigate } from "react-router-dom";
import TpDealCard from "../card/dealCard/TpDealCard";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import { Container, Row, Col } from "react-bootstrap";

export default function FeaturedDeals() {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [deals, setDeals] = useState([]);

  const fetchAllFeaturedDeals = () => {
    const formData = new FormData();
    formData.append("deal_type", "Hot Deals");

    axios
      .post(`${baseUrl}/customer/deals/fetchAllDeals`, formData, {
        headers: { "Content-Type": "multipart/formData" },
      })
      .then((res) => {
        console.log("response called from the deals function ", res.data);
        if (res.data.success) {
          setDeals(res.data.deals);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  useEffect(() => {
    fetchAllFeaturedDeals();
  }, []);

  return (
    <section className="fd-section">
      <div className="fd-header">
        <div>
          <h2 className="fd-title">Featured Deals</h2>
          <p className="fd-subtitle">Hand-picked deals just for you</p>
        </div>
        <button className="fd-view-all" onClick={() => navigate("/deals")}>
          View All <ArrowRight size={16} />
        </button>
      </div>

      {/* ✅ px-4 hata diya — CSS file me hi padding define hai, ab conflict nahi */}
      <Container fluid className="fd-container">
        <Row className="fd-grid gx-4 gy-4">
          {deals?.map((deal) => (
            <Col
              key={deal.id}
              xxl={3}
              xl={3}
              lg={4}
              md={6}
              sm={10}
              xs={12}
              className="fd-col"
            >
              <div className="fd-card-wrapper">
                <TpDealCard deal={deal} />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}